// material-ui

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';

import TextField from '@mui/material/TextField';
import { IconCheck } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const ForgotSuccess = ({ forceOpen }: { forceOpen: Function }) => {
    const theme = useTheme();
    //onClick={() => forceOpen('login')}
    const { forceLogin } = useAuth();
    const doLogin = () => {
        forceLogin(true);
        forceOpen('login')
    }
    return (
        <>
            <Box  sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap:'15px', }}>
                <IconCheck color="#04881d" size={60} style={{background:'#fff', borderRadius:'15px'}} />
                <Typography
                    variant="h6"
                    sx={{ fontSize: '1.2rem', fontWeight: '400', color: theme.palette.text.dark,  mb: '15px',  }}
                >
                    {' '}
                    Password updated successfully
                </Typography>
                <Grid item sx={{ display: 'flex', alignItems:'center', gap:'15px', marginBottom:'20px' }}>
                    <Button
                        sx={{ fontSize: '1rem', fontWeight: '800', mt: '0px', pr: '30px', pl:'30px', width:'100%',  height:'44px', borderRadius:'4px !important',  background:theme.palette.secondary.main, textDecoration: 'none', borderWidth:'1px', borderStyle:'solid',  borderColor: theme.palette.secondary.main,
                            color: '#121212',
                            ':hover':{
                                background:theme.palette.secondary.main,
                            },
                            [theme.breakpoints.down(600)]: {
                                fontSize: '.9rem',  fontWeight: '600', width:'336px'
                            },
                            [theme.breakpoints.down(374)]: {
                                fontSize: '.9rem',  fontWeight: '600', width:'100%'
                            },
                         }}
                        // component={Link}
                        onClick={() => doLogin()}
                    >
                        {' '}
                        Login
                    </Button>
                    {/* <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: '400' }}>
                        {' '}
                        Login
                    </Typography> */}
                </Grid>
            </Box>
        </>
    );
};

export default ForgotSuccess;
